import DatePicker, { DatePickerProps } from 'react-datepicker';
import { useIntl, MessageDescriptor } from 'react-intl';
import 'react-datepicker/dist/react-datepicker.css';
import classNames from 'classnames';
import { useId } from 'react';
import styles from './DatePicker.module.scss';
import TestIds, { formatTestId } from '../../tests/TestIds';
import Tooltip from '../Tooltip/Tooltip';

type Props = DatePickerProps & {
	label?: MessageDescriptor;
	tooltipContent?: MessageDescriptor;
	className?: string;
	labelClassName?: string;
};

const Day = (day: number) => {
	return (
		<span data-cy={formatTestId(TestIds.DatePickerDay_0, `${day}`)} className={styles.day}>
			{day}
		</span>
	);
};

export default ({ label, tooltipContent, className, labelClassName, ...restProps }: Props) => {
	const { formatMessage } = useIntl();
	const inputId = useId();

	return (
		<div className={styles.datepicker} data-cy={TestIds.DatePicker}>
			{label && (
				<label className={classNames(styles.label, labelClassName)} htmlFor={inputId}>
					{formatMessage(label)}
					{tooltipContent && (
						<Tooltip
							infoIconVisible
							content={
								<div className={styles.tooltip}>
									{formatMessage(tooltipContent)}
								</div>
							}
						/>
					)}
				</label>
			)}
			<div className={classNames(styles.container, className)}>
				<DatePicker
					id={inputId}
					autoComplete="off"
					fixedHeight
					dateFormat="yyyy-MM-dd"
					formatWeekDay={(name) => name.slice(0, 1)}
					popperPlacement="bottom-start"
					isClearable
					placeholderText={restProps.placeholderText}
					className={styles.datePicker}
					popperClassName={styles.popper}
					renderDayContents={Day}
					{...restProps}
				/>
			</div>
		</div>
	);
};
